// `/admin/audit-log/$id` (croqui `admin/audit-log.tsx#LinhaAuditoria`). Foco: **o antes e
// depois**.
//
// Desde WEB-84 o componente é o CONTEÚDO do `RouteDrawer` da rota-pai: o cabeçalho (a
// ação, o id e o autor, mais o botão de fechar) é do drawer, e a trilha continua desenhada
// embaixo, inclusive em deep link. Sem step-up.

import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { isApiError } from '../api/errors.ts';
import { ErrorState } from '../components/app/error-state.tsx';
import { CardSkeleton } from '../components/app/skeletons.tsx';
import { Btn } from '../components/kit/btn.tsx';
import { Empty } from '../components/kit/empty.tsx';
import { AuditDetail } from '../features/admin-audit/audit-detail.tsx';
import { auditEntryOptions } from '../features/admin-audit/queries.ts';

function AuditEntryPage() {
  const { id } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();
  const entry = useQuery(auditEntryOptions(id));
  const notFound = isApiError(entry.error) && entry.error.status === 404;

  const back = (): void => {
    void navigate({ to: '/admin/audit-log', search });
  };

  if (entry.isPending) {
    return <CardSkeleton lines={6} />;
  }
  if (notFound) {
    return (
      <Empty
        title="Linha não encontrada"
        hint="Esse id não existe na trilha. Ele pode ter sido copiado errado ou pertencer a outro ambiente."
        action={
          <Btn kind="card" small onClick={back}>
            Voltar para a trilha
          </Btn>
        }
      />
    );
  }
  if (entry.data === undefined) {
    return (
      <ErrorState
        error={entry.error}
        onRetry={() => {
          void entry.refetch();
        }}
      />
    );
  }
  return <AuditDetail entry={entry.data} />;
}

export const Route = createFileRoute('/admin/audit-log/$id')({ component: AuditEntryPage });
